module.exports = __webpack_public_path__ + "static/logo-b4d2c4622a25e9451d0c507f82ed0d77.svg";